@if (showHeader()) {
<app-header></app-header>
} @if (showHeader() && store.showBannerMaintenance()) {
<app-maintenance-scroller></app-maintenance-scroller>
}
<div class="m-body" id="m-body">
  <router-outlet></router-outlet>
</div>
@if (showFooter()) {
<app-footer></app-footer>
}
<app-snackbar></app-snackbar>
